<template>
  <van-popup
    class="popup_box"
    v-model:show="showValue"
    round
    :style="{ padding: '64px' }"
    :closeOnClickOverlay="false"
    :transition-appear="true"
    transition="scaleIn"
  >
    <div @click="onClose" class="popup_close close_center"><span></span></div>
    <div class="popup">
      <van-swipe
        :touchable="true"
        class="banners"
        id="mswipe"
        :autoplay="3000"
        indicator-color="white"
        :key="swipeKey"
        @change="onChange"
      >
        <van-swipe-item @click="onClickBanner(banner)" v-for="(banner, i) in banners" :key="i">
          <img :src="banner.cover" class="img" :alt="banner.name" />
        </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator">
            <span
              v-for="(item, index) in banners"
              :key="index"
              :class="{ active: index === currentIndex }"
              @click="currentIndex = index"
            ></span>
          </div>
        </template>
      </van-swipe>
    </div>
  </van-popup>
</template>

<script>
import { getLocalStorage, Key, removeLocalStorage, setLocalStorage } from '@/common/localStorage'
import { BUS, POPUP } from '@/event/EventCenter'
import { getLocale } from '@/locales'
import { useEnvelopeStore } from '@/stores/envelope'
import { useLobbyStore } from '@/stores/lobby'
import { useUserStore } from '@/stores/user'
import { encodeBase64 } from '@/utils/helper'
import dayjs from 'dayjs'
import { mapActions, mapState } from 'pinia'
export default {
  name: 'PopupHome',
  data() {
    return {
      showValue: false,
      banners: [],
      currentIndex: 0,
      swipeKey: 0,
      todayShowed: getLocalStorage(Key.todayShowed) == dayjs().format('YYYY-MM-DD')
    }
  },
  watch: {
    hasPopup(newValue, oldValue) {
      if (newValue != oldValue) {
        this.showValue = newValue
      }
    }
  },
  computed: {
    ...mapState(useLobbyStore, ['hasPopup']),
    ...mapState(useUserStore, ['isLogin'])
  },
  mounted() {
    if (getLocalStorage(Key.clickEnvlopePopup) == 'true') {
      removeLocalStorage(Key.clickEnvlopePopup)
      if (this.isLogin) {
        this.onClose()

        this.envelope().then((res) => {
          if (res.id > 0 && res.status < 3) {
            //用户身上有红包 直接进入活动页主页
            window.location.href = `${window.envelopeUrl}/?active=${getLocalStorage(Key.Token)}&lang=${getLocale()}&cid=hbzz&channel=web`
          } else {
            //此时用户身上无红包 自动开启红包动画
            this.$bus.$emit(BUS.SHOW_ACTIVE_BOX, { hasOpened: false })
          }
        })
      }
    } else {
      if (this.todayShowed) return
      this.popup().then((r) => {
        console.log('home popup', r.popUps)
        this.banners = r.popUps
        setLocalStorage(Key.todayShowed, dayjs().format('YYYY-MM-DD'))
        setTimeout(() => {
          this.swipeKey++
        }, 1000)
      })
    }
  },

  methods: {
    ...mapActions(useLobbyStore, { popup: 'popup', enterGame: 'enterGame' }),
    ...mapActions(useEnvelopeStore, { envelope: 'envelope', create: 'create' }),
    onClose() {
      this.showValue = false
    },
    onChange(index) {
      this.currentIndex = index
    },
    onClickBanner(banner) {
      if (banner.cmd == 'game') {
        if (this.isLogin) {
          this.enterGame(parseInt(banner.cmdValue)).then((response) => {
            this.$router.push({ name: 'gameView', params: { currentGameUrl: response.url } })
          })
        } else {
          this.$bus.$emit(BUS.SHOW_POPUP, { from: 'gridListGame', to: POPUP.LOGIN, show: true })
        }
      } else if (banner && banner.cmd == 'h5') {
        window.location.href = banner.cmdValue
      } else if (banner && banner.cmd == 'deeplink') {
        this.onClose()
        this.$router.replace(`/${banner.cmdValue}`)
      } else if (banner && banner.cmd == 'active') {
        if (banner.cmdValue == 'redenvelope') {
          this.onClose()
          //  红包活动
          if (this.isLogin) {
            this.envelope().then((res) => {
              if (res.id > 0 && res.status < 3) {
                //用户身上有红包 直接进入活动页主页
                // window.location.href = `${window.envelopeUrl}/?active=${getLocalStorage(Key.Token)}&lang=${getLocale()}&cid=hbzz&channel=web`
                this.$bus.$emit(BUS.SHOW_ACTIVE_BOX, { hasOpened: false, showProgress: true })
              } else {
                //此时用户身上无红包 自动开启红包动画
                this.$bus.$emit(BUS.SHOW_ACTIVE_BOX, { hasOpened: false })
              }
            })
          } else {
            //弹出活动页注册弹窗
            setLocalStorage(Key.clickEnvlopePopup, true)
            this.$bus.$emit(BUS.SHOW_POPUP, {
              from: 'envelopPopup',
              to: POPUP.REGISTER,
              show: true
            })
          }
        }
      } else if (banner && banner.cmd == 'luckywheel') {
        if (!this.isLogin) {
          this.$bus.$emit(BUS.SHOW_POPUP, { from: 'banner', to: POPUP.LOGIN, show: true })
          return
        }
        const url = `${banner.cmdValue}?token=${encodeBase64(getLocalStorage(Key.Token))}`
        this.$router.push({ name: 'gameView', params: { currentGameUrl: url } })
      }
      // console.log('onClickBanner', getFileNameFromUrl(banner.name))
    }
  }
}
</script>

<style lang="scss" scoped>
.popup_box {
  width: 6.5rem;
  height: auto;
  margin: 0 auto;
  padding: 0 !important;
  overflow: visible !important;
  // border: solid 0.04rem transparent;
  // border-radius: 0.16rem;
  background-color: rgba($color: #000000, $alpha: 0);
  // background-image: linear-gradient(#000, #000),
  //   linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
  // background-origin: border-box;
  // background-clip: content-box, border-box;
  text-align: center;
  // overflow: hidden;

  .popup {
    width: 6rem;
    height: auto;
    // border-radius: 0.12rem;
    display: block;
    padding: 2%;
    margin: 0.12rem auto;

    .custom-indicator {
      display: flex;
      justify-content: center;
      margin-top: -0.1rem;
    }

    .custom-indicator span {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #825c2d;
      margin: 0 5px;
      cursor: pointer;
    }

    .custom-indicator span.active {
      background: #ffddac;
      /* Active color */
    }

    .banners {
      width: 100%;
      // height: 3.25rem;

      .img {
        width: 100%;
        // height: 1.8rem;
        // border-radius: 0.2rem;
      }
    }
  }

  .close_center {
    display: flex !important;
    margin-top: -0.5rem !important;
    justify-content: center;
    align-items: flex-start;
  }

  .popup_close {
    height: 0.8rem;
    width: 0.8rem;
    border-radius: 50%;
    background-color: #000;
    border: solid 4px transparent;
    background-image: linear-gradient(#000, #000),
      linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
    background-origin: border-box;
    background-clip: content-box, border-box;
    margin-top: -1.2rem;
    text-align: center;
    position: absolute;
    display: block;
    z-index: 2;
    margin-left: 90%;

    span {
      display: inline-block;
      width: 0.6rem;
      height: 0.08rem;
      background-color: #aa884a;
      background-image: linear-gradient(
        130deg,
        #dfc572 0%,
        #916c38 50%,
        #825c2d 50.1%,
        #aa884a 100%
      );
      transform: rotate(45deg);
      margin-top: 0.355rem;
    }

    span::after {
      content: '';
      display: block;
      width: 0.6rem;
      height: 0.08rem;
      background-color: #aa884a;
      background-image: linear-gradient(
        130deg,
        #dfc572 0%,
        #916c38 50%,
        #825c2d 50.1%,
        #aa884a 100%
      );
      transform: rotate(-90deg);
    }
  }
}

@keyframes scaleIn {
  0% {
    scale: 0;
  }

  100% {
    scale: 1;
  }
}
</style>
